import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Divider, Icon, Item, Label } from "semantic-ui-react";
import { getClockifyOverview, stopActiveTimer } from "../api/clockify";
import PageLoader from "../components/PageLoader";
import {
  Card,
  EmptyState,
  Page,
  PageHeader,
  SectionTitle,
} from "../components/ui";

const calcSeconds = (startTimestamp) => {
  const now = Math.round(new Date().getTime() / 1000);
  const seconds = now - startTimestamp;
  const str = new Date(seconds * 1000).toISOString().substr(11, 8);
  return str;
};

function Clockify() {
  const [loading, setLoading] = useState(true);
  const [overview, setOverview] = useState();
  const [stopping, setStopping] = useState(false);
  const [activeSeconds, setActiveSeconds] = useState();

  const handleStopTimer = () => {
    setStopping(true);
    stopActiveTimer()
      .then((res) => setOverview(res.data.data))
      .catch(() => toast("Failed to stop timer", { type: "error" }))
      .finally(() => setStopping(false));
  };

  useEffect(() => {
    getClockifyOverview()
      .then((res) => setOverview(res.data.data))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const setSeconds = () => {
      if (overview?.active) {
        setActiveSeconds(calcSeconds(overview.active.start_timestamp));
      }
    };

    const interval = setInterval(setSeconds, 1000);
    return () => clearInterval(interval);
  }, [overview?.active]);

  if (loading) return <PageLoader>Clockify loading...</PageLoader>;

  return (
    <Page maxWidth={960}>
      <PageHeader title="Time Tracking" />

      {overview.active && (
        <Card>
          <Item.Group>
            <TimeEntry entry={overview.active} last>
              <Button as="div" labelPosition="right">
                <Button
                  color="red"
                  onClick={handleStopTimer}
                  loading={stopping}
                  disabled={stopping}
                >
                  <Icon name="clock" />
                  Stop Timer
                </Button>
                <Label
                  style={{ minWidth: "80px" }}
                  color="grey"
                  pointing="left"
                >
                  {activeSeconds ?? "--:--:--"}
                </Label>
              </Button>
            </TimeEntry>
          </Item.Group>
        </Card>
      )}
      <SectionTitle style={{ marginTop: "8px" }}>Previous Timers</SectionTitle>
      <Card>
        {overview.entries.length === 0 && (
          <EmptyState icon="clock" title="No timers found" />
        )}
        {overview.entries.map((x, i) => (
          <TimeEntry
            key={`entry-${i}`}
            entry={x}
            last={i === overview.entries.length - 1}
          />
        ))}
      </Card>
    </Page>
  );
}

function TimeEntry({ entry, last, children }) {
  return (
    <>
      <Item>
        <Item.Content>
          <Item.Header>{entry.description}</Item.Header>
          <Item.Description>{entry.project}</Item.Description>
          <Item.Meta>
            {entry.start}
            {entry.end && (
              <>
                {" "}
                - {entry.end} - {entry.duration}
              </>
            )}
          </Item.Meta>
          <Item.Meta>
            {entry.tags.map((x) => (
              <Label
                key={x}
                color="teal"
                size="mini"
                tag
                style={{ marginRight: "14px" }}
              >
                {x}
              </Label>
            ))}
          </Item.Meta>
          <Item.Extra>{children}</Item.Extra>
        </Item.Content>
      </Item>
      {!last && <Divider />}
    </>
  );
}

export default Clockify;
